import { Button, Modal, notification } from "antd";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";
import arrow from "../../../assets/images/button-arrow-blue.svg";
import close from "../../../assets/images/close.svg";
import icon1_5GB from "../../../assets/images/modal-icon-game-result-1.5GB.svg";
import icon1GB from "../../../assets/images/modal-icon-game-result-1GB.svg";
import icon2GB from "../../../assets/images/modal-icon-game-result-2GB.svg";
import iconError from "../../../assets/images/modal-icon-payment-error.svg";
import { MeDto } from "../../../core/models/dtos/me.dto";
import { ApiEvent } from "../../../core/models/enums/apiEvent";
import { RewardDescription } from "../../../core/models/enums/rewardDescription";
import { apiEventRequest } from "../../../core/services/eventService/apiEvent/repository";
import FirebaseService from "../../../core/services/firebaseService/firebase.service";
import {
  rewardConsume,
  rewardConsumeReset,
} from "../../../core/services/userRewardService/rewardConsume/actions";
import { RewardConsumeState } from "../../../core/services/userRewardService/rewardConsume/types";
import { Errors } from "../../../core/utilities/errors";
import { Helpers } from "../../../core/utilities/helpers";
import { IStore } from "../../../core/utilities/reducers";
import { UI } from "../../../core/utilities/ui";
import FirebaseKey from "../../FirebaseKey/FirebaseKey";
import "./GameResultModal.scss";

interface IProps {
  me?: MeDto;
  rewardDescription: RewardDescription;
  callback: () => void;
  rewardConsumeState: RewardConsumeState;
  rewardConsume: () => void;
  rewardConsumeReset: () => void;
}

interface ModalModel {
  icon: string;
  titleKey: string;
  textKey: string;
  buttonKey: string;
}

const GameResultModal = (props: IProps) => {
  const [isRepeatClicked, setIsRepeatClicked] = useState(false);

  useEffect(() => {
    switch (props.rewardDescription) {
      case RewardDescription.bigPrize:
        FirebaseService.logEvent(FirebaseService.user_count_big_reward_won);
        break;
      case RewardDescription.midPrize:
        FirebaseService.logEvent(FirebaseService.user_count_mid_reward_won);
        break;
      case RewardDescription.smallPrize:
        FirebaseService.logEvent(FirebaseService.user_count_small_prize_won);
        break;
    }
    return () => props.rewardConsumeReset();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    function showRedeemNotification() {
      notification.open({
        closeIcon: <React.Fragment />,
        className: "game-result-notification",
        placement: "bottomRight",
        message: (
          <FirebaseKey firebaseKey={FirebaseService.redeem_reward_tool_tip} />
        ),
        duration: 3,
        onClose: () => props.callback(),
      });
    }

    if (props.rewardConsumeState.data) {
      apiEventRequest({
        ...Helpers.getApiEventCoreData(props.me),
        event: ApiEvent.POINTS_REWARD_DIRECT,
      }).catch();
      showRedeemNotification();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.rewardConsumeState]);

  function handleConsume(): void {
    FirebaseService.logEvent(
      FirebaseService.user_count_direct_reward_button_clicked,
      { newcomer: !props.me?.termsAcceptanceDate }
    );
    props.rewardConsume();
  }

  function handleRepeatGame(): void {
    setIsRepeatClicked(true);
    FirebaseService.logEvent(
      FirebaseService.user_count_playagain_button_clicked,
      { newcomer: !props.me?.termsAcceptanceDate }
    );
    apiEventRequest({
      ...Helpers.getApiEventCoreData(props.me),
      event: ApiEvent.PLAY_AGAIN,
    }).catch();
    notification.open({
      closeIcon: <React.Fragment />,
      className: "game-result-notification",
      placement: "bottomRight",
      message: "Ödülün cüzdanına yüklendi, kazanmaya devam et!",
      duration: 3,
      onClose: () => props.callback(),
    });
  }

  function getModalModel(): ModalModel {
    switch (props.rewardDescription) {
      case RewardDescription.bigPrize:
        return {
          icon: icon2GB,
          titleKey: FirebaseService.congrats_highest_prize_header_v2,
          textKey: FirebaseService.congrats_highest_prize_desc,
          buttonKey: FirebaseService.congrats_highest_prize_button,
        };
      case RewardDescription.midPrize:
        return {
          icon: icon1_5GB,
          titleKey: FirebaseService.congrats_middle_prize_header_v2,
          textKey: FirebaseService.congrats_middle_prize_desc,
          buttonKey: FirebaseService.congrats_middle_prize_button,
        };
      case RewardDescription.smallPrize:
        return {
          icon: icon1GB,
          titleKey: FirebaseService.congrats_lowest_prize_header_v2,
          textKey: FirebaseService.congrats_lowest_prize_desc,
          buttonKey: FirebaseService.congrats_lowest_prize_button,
        };
      default:
        return {
          icon: iconError,
          titleKey: Errors.errorGenericTitle,
          textKey: Errors.errorGenericText,
          buttonKey: "TAMAM",
        };
    }
  }

  function isRewardConsumeButton(): boolean {
    return props.rewardDescription === RewardDescription.smallPrize;
  }

  return (
    <Modal
      wrapClassName="game-result-modal-wrapper"
      className="game-result-modal"
      maskStyle={UI.modalMaskStyle()}
      visible
      closeIcon={<img src={close} alt="close" onClick={handleRepeatGame} />}
      footer={false}
      centered
      destroyOnClose
    >
      <div className="content">
        <img className="icon" src={getModalModel().icon} alt="icon" />
        <FirebaseKey className="title" firebaseKey={getModalModel().titleKey} />
        <div
          className="text-wrapper"
          onClick={() =>
            FirebaseService.logEvent(
              FirebaseService.user_count_wallet_clicked,
              { newcomer: !props.me?.termsAcceptanceDate }
            )
          }
        >
          <FirebaseKey className="text" firebaseKey={getModalModel().textKey} />
        </div>
        <div className="buttons">
          {isRewardConsumeButton() && (
            <Button
              className="app-button secondary"
              disabled={
                props.rewardConsumeState.loading ||
                props.rewardConsumeState.data
              }
              onClick={handleConsume}
            >
              HEMEN YÜKLE
            </Button>
          )}
          <Button
            className="app-button"
            disabled={props.rewardConsumeState.loading || isRepeatClicked}
            onClick={handleRepeatGame}
          >
            <FirebaseKey firebaseKey={getModalModel().buttonKey} />
            <img className="arrow" src={arrow} alt="arrow" />
          </Button>
        </div>
      </div>
    </Modal>
  );
};

const mapDispatchToProps = (dispatch: Dispatch) => {
  return bindActionCreators(
    {
      rewardConsume,
      rewardConsumeReset,
    },
    dispatch
  );
};
const mapStateToProps = (store: IStore) => {
  return {
    me: store.setMe.me,
    rewardConsumeState: store.rewardConsume,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(GameResultModal);
